import { Component, createRef } from 'react';
import { observe } from 'mobx';
import ApplicationState from "../mobx/ApplicationState";

import "./EmbeddedEmulator.scss";
import GameData from "../mobx/GameData";

const allButtons = ['up', 'down', 'left', 'right', 'select', 'start', 'a', 'b'];

export class EmbeddedEmulator extends Component {

    emuIframe = null;
    emulatorButtonActions = Object.fromEntries([
        ...allButtons.map(a => [a + 'Pressed', () => {}]),
        ...allButtons.map(a => [a + 'Released', () => {}])
    ]);


    constructor(props) {
        super(props);

        this.state = {
            romData: null,
            hasInitialized: false,
            initInterval: null
        }
        this.emuIframe = createRef();
    }

    async initialize() {
        if (this.state.initInterval) {
            clearInterval(this.state.initInterval);
        }

        if (!this.state.romData) { return; }
        await new Promise(resolve => this.setState({initInterval: setInterval(() => {
            try {
                this.emuIframe.current.contentWindow.emu.preloadUrl(this.state.romData);
                this.emulatorButtonActions = Object.fromEntries([
                    ...allButtons.map(methodS => {
                        const method = methodS + 'Pressed';
                        return [method, (e) => { this.emuIframe.current.contentWindow.emu.controller[method](); e.preventDefault() }];
                    }), 
                    ...allButtons.map(methodS => {
                        const method = methodS + 'Released';
                        return [method, (e) => { this.emuIframe.current.contentWindow.emu.controller[method](); e.preventDefault() }];
                    }), 

                ]);

                clearInterval(this.state.initInterval);
                this.initInterval = null;
            } catch (e) {
                console.debug('Failed initializing emulator, will retry', e);
            }
        }, 500)}, resolve));
    }

    async componentDidMount() {
        this.applicationStateCleanup = observe(ApplicationState, () => { 
            this.forceUpdate()
        });

        this.gameDataCleanup = observe(GameData, async () => {
            if (this.romData) {
                URL.revokeObjectURL(this.romData);
            }
            this.romData = await this.getRomData();
            this.initialize();
        });
        this.setState({romData: await this.getRomData()});
        this.initialize();
    }

    async getRomData() {

        if (this.props.game) {
            return await GameData.getPatchedRomWithData(this.props.game);
        } else {
            return await GameData.getCurrentPatchedRom(this.props.forceLevel ?? null, this.props.forceLevelData ?? null);
        }
    }

    async skipLevel() {
        const e = new Event("unused");
        this.emulatorButtonActions.selectPressed(e);
        this.emulatorButtonActions.leftPressed(e);
        this.emulatorButtonActions.rightPressed(e);
        await new Promise(resolve => setTimeout(resolve, 20))
        this.emulatorButtonActions.selectReleased(e);
        this.emulatorButtonActions.leftReleased(e);
        this.emulatorButtonActions.rightReleased(e);
        this.emuIframe.current.focus();
    }

    componentWillUnmount() {
        if (this.applicationStateCleanup) {
            this.applicationStateCleanup();
        }
        if (this.gameDataCleanup) {
            this.gameDataCleanup();
        }

        if (this.state.initInterval) {
            clearInterval(this.state.initInterval);
        }
        if (this.romData) {
            URL.revokeObjectURL(this.romData);
        }
    }

    render() {
        if (this.state.romData) {
            return (
                <div className="embedded-emulator">
                    <iframe ref={this.emuIframe} src="/nez/index_embed.html" title="emulator" />

                    <div className="controller-disp">
                        <div className="directions">
                            <button className="up" onMouseDown={e => this.emulatorButtonActions.upPressed(e)} onTouchStart={e => this.emulatorButtonActions.upPressed(e)} onTouchEnd={e => this.emulatorButtonActions.upReleased(e)} onMouseUp={e => this.emulatorButtonActions.upReleased(e)}>Up</button>
                            <button className="left" onMouseDown={e => this.emulatorButtonActions.leftPressed(e)} onTouchStart={e => this.emulatorButtonActions.leftPressed(e)} onTouchEnd={e => this.emulatorButtonActions.leftReleased(e)} onMouseUp={e => this.emulatorButtonActions.leftReleased(e)}>Left</button>
                            <button className="right" onMouseDown={e => this.emulatorButtonActions.rightPressed(e)} onTouchStart={e => this.emulatorButtonActions.rightPressed(e)} onTouchEnd={e => this.emulatorButtonActions.rightReleased(e)} onMouseUp={e => this.emulatorButtonActions.rightReleased(e)}>Right</button>
                            <button className="down" onMouseDown={e => this.emulatorButtonActions.downPressed(e)} onTouchStart={e => this.emulatorButtonActions.downPressed(e)} onTouchEnd={e => this.emulatorButtonActions.downReleased(e)} onMouseUp={e => this.emulatorButtonActions.downReleased(e)}>Down</button>
                        </div>

                        <div className="middle">
                            <button className="select" onMouseDown={e => this.emulatorButtonActions.selectPressed(e)} onTouchStart={e => this.emulatorButtonActions.selectPressed(e)} onTouchEnd={e => this.emulatorButtonActions.selectReleased(e)} onMouseUp={e => this.emulatorButtonActions.selectReleased(e)}>Select</button>
                            <button className="start" onMouseDown={e => this.emulatorButtonActions.startPressed(e)} onTouchStart={e => this.emulatorButtonActions.startPressed(e)} onTouchEnd={e => this.emulatorButtonActions.startReleased(e)} onMouseUp={e => this.emulatorButtonActions.startReleased(e)}>Start</button>
                        </div>

                        <div className="buttons">
                            <button className="b" onMouseDown={e => this.emulatorButtonActions.bPressed(e)} onTouchStart={e => this.emulatorButtonActions.bPressed(e)} onTouchEnd={e => this.emulatorButtonActions.bReleased(e)} onMouseUp={e => this.emulatorButtonActions.bReleased(e)}>B</button>
                            <button className="a" onMouseDown={e => this.emulatorButtonActions.aPressed(e)} onTouchStart={e => this.emulatorButtonActions.aPressed(e)} onTouchEnd={e => this.emulatorButtonActions.aReleased(e)} onMouseUp={e => this.emulatorButtonActions.aReleased(e)}>A</button>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="embedded-emulator">
                    <small className="text-muted fail-notice">Game not available</small>
                </div>
            );
                
        }
    }
}